import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import MaterialTable from "@material-table/core";
import Select, { ActionMeta } from "react-select";

import * as APIModels from "../../../../models";
import { TylerRecordService as RecordsService } from "../../../../services/RecordsService";
import Footer from "../../../../components/shared/Footer";
import CaseInformation from "../components/CaseInformationCard";
import PartyTable from "../components/PartyTable";
import { authenticationService } from "../../../../services/authentication.service";
import {
    TylerEnvelopeService,
    TylerFeeService,
} from "../../../../services/SubmissionService";
import DocumentModal from "./DocumentModal";
import FeeTable from "../components/FeeTable";
import {
    TylerAdminService,
    TylerPaymentService,
} from "../../../../services/ClientService";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../../../components/shared/modals/ErrorModal";
import { Globals } from "../../../../helpers/globals";

type MyOptionType = { label: string; value: string };

export default function Existing() {
    const { id } = useParams<{ id: string }>();
    const options: MyOptionType[] = [];
    const [_errorMessage, setErrorMessage] = useState<string>();
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [ucn, setUcn] = useState("");
    const [isLoading, setIsLoading] = useState(
        true && ucn && (ucn?.length ?? 0) > 0
    );
    const [submission, setSubmission] = useState({
        id: id,
    } as APIModels.Submission);
    const [partyOptions, setPartyOptions] = useState(options);
    const [paymentOptions, setPaymentOptions] = useState(options);
    const [attorneyOptions, setAttorneyOptions] = useState(options);
    const [isCalculating, setIsCalculating] = useState(false);

    const [isSubmitting, _setIsSubmitting] = useState(false);
    const [calculateError, setCalculateError] = useState("");

    // progression state management
    const [currentStep, setCurrentStep] = useState(1);

    useEffect(() => {
        TylerEnvelopeService.access({ id: id }).then((resp) => {
            if (resp.successful && resp.data) {
                setSubmission({
                    ...submission,
                    id: id,
                    caseData: {
                        submissionID: id,
                        // these will be idsfor tyler
                        // except for tyler
                        ucn: Globals.MaybeId(resp.data?.caseData?.ucn),
                        countyID: Globals.MaybeId(
                            resp.data?.caseData?.countyID
                        ),
                        courtCaseNumber:
                            resp.data?.caseData?.courtCaseNumber ?? "",
                        caseTitle: resp.data?.caseData?.caseTitle ?? "",
                        divisionID: Globals.MaybeId(
                            resp.data?.caseData?.divisionID
                        ),
                        caseTypeID: Globals.MaybeId(
                            resp.data?.caseData?.caseTypeID
                        ),
                        clientCaseNumber:
                            resp.data?.caseData?.clientCaseNumber ?? "",
                    } as APIModels.CaseData,
                });
                if (resp?.data?.caseData?.ucn) {
                    setUcn(resp.data?.caseData?.ucn);
                }
            }
        });
    }, [id]);

    useEffect(() => {
        //console.log("ucn", ucn && ucn.length > 0);
        if (ucn && ucn.length > 0) {
            setCurrentStep(2);
            console.log({
                "fire getCaseByUcn": {
                    countyId: submission.caseData?.countyID ?? "",
                    divsionId: submission.caseData?.divisionID ?? "",
                    ucn: ucn,
                },
            });
            RecordsService.getCaseByUcn({
                countyId: submission.caseData?.countyID ?? APIModels.EmptyGuid,
                divsionId:
                    submission.caseData?.divisionID ?? APIModels.EmptyGuid,
                ucn: ucn!,
            })
                .then((resp) => {
                    /*
                    console.log({ "response recieved": resp });
                    //if (resp.data !== null && resp.successful) {
                    //
                    //
                    if (resp.data !== null) {
                        setSubmission({
                            ...submission,
                            caseData: {
                                countyID: submission.caseData?.countyID
                                    ? submission.caseData?.countyID
                                    : APIModels.EmptyGuid,
                                divisionID: resp.data?.divisionID
                                    ? resp.data?.divisionID
                                    : APIModels.EmptyGuid,
                                caseTypeID: resp.data?.caseTypeID
                                    ? resp.data?.caseTypeID
                                    : submission.caseData?.caseTypeID!,
                                ucn:
                                    resp.data?.ucn !== APIModels.EmptyGuid
                                        ? resp.data?.ucn
                                        : submission.caseData?.ucn ?? "",
                                caseTitle:
                                    resp.data?.caseTitle !== APIModels.EmptyGuid
                                        ? resp.data?.caseTitle
                                        : submission.caseData?.caseTitle ?? "",
                                courtCaseNumber:
                                    resp.data?.caseNumber !==
                                    APIModels.EmptyGuid
                                        ? resp.data?.caseNumber
                                        : submission.caseData
                                              ?.courtCaseNumber ?? "",
                            } as APIModels.CaseData,
                            parties: resp.data?.parties ?? [],
                        });
                        onUpdateParties(resp.data?.parties ?? []);
                    } else {
                        setErrorMessage(resp.errorMessage!);
                    }
                    */
                })
                .catch((err) => {
                    setErrorMessage(err);
                })
                .then(() => setIsLoading(false));

            console.log("countyId", submission.caseData?.countyID);
            console.log("Submission ID", submission.id);
        }
    }, [ucn]);

    useEffect(() => {
        // this will always work
        TylerAdminService.getAttorneys().then((res) => {
            if (res.successful && res) {
                setAttorneyOptions(
                    res.data?.map((v, i) => {
                        return {
                            value: v.id!,
                            label: v.firstName + " " + v.lastName,
                        };
                    }) ?? []
                );
            } else {
                setErrorMessage(res.errorMessage!);
            }
        });

        // this will always work
        TylerPaymentService.getAll()
            .then((res) => {
                if (res.successful && res) {
                    setPaymentOptions(
                        res.data?.map((v, i) => {
                            return {
                                value:
                                    v.paymentAccountID! ?? APIModels.EmptyGuid,
                                label: v.accountName! ?? "Error: Do not use",
                            };
                        }) ?? []
                    );
                }
            })
            .catch((err) => {
                setErrorMessage(err);
            });
    }, [submission.caseData?.ucn]);

    const handleDocumentClose = () => setShowDocumentModal(false);
    const handleDocumentOpen = () => setShowDocumentModal(true);

    const addDocument = (document: APIModels.Document) => {
        const newDocuments = [...(submission.documents ?? [])];
        newDocuments.push(document);
        setSubmission({ ...submission, documents: newDocuments });
        if (currentStep < 4) {
            const newStep = currentStep + 1;
            console.log("newStep", newStep);
            setCurrentStep(newStep);
        } else {
            console.log("Submission.Documents", newDocuments);
            console.log("Submission.Parties", submission.parties);
            if (newDocuments.length > 0 && submission.parties!.length > 0) {
                setCurrentStep(4);
            }
        }
    };

    const onUpdateParties = (parties: APIModels.Party[]) => {
        setSubmission({ ...submission, parties: parties });

        setPartyOptions(
            parties.map((v, i) => {
                return {
                    value: v.id!,
                    label:
                        v.name && v.name.length > 0
                            ? v.name
                            : v.firstName + " " + v.lastName,
                };
            })
        );
        if (currentStep < 4 && parties.length == 0) {
            const newStep = currentStep + 1;
            setCurrentStep(newStep);
        } else {
            console.log("Submission.Documents", submission.documents);
            console.log("Submission.Parties", parties);
            if (parties.length > 0 && submission.documents!.length > 0) {
                setCurrentStep(4);
            }
        }
    };

    const errorModalProps: ErrorModalProps = {
        errorMessage: "",
        onClose: () => {
            setErrorMessage("");
            setShowErrorModal(false);
        },
    };

    const filterOption = (option: MyOptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Firms</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Cases</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        {submission.caseData?.ucn ? (
                                            <span>
                                                {" "}
                                                File into Existing Case ucn:{" "}
                                                {submission.caseData.ucn}
                                            </span>
                                        ) : (
                                            <span> New Case </span>
                                        )}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {showErrorModal && <ErrorModal {...errorModalProps} />}
                <DocumentModal
                    show={showDocumentModal}
                    submission={submission}
                    countyId={
                        submission.caseData?.countyID ?? APIModels.EmptyGuid
                    }
                    caseTypeId={
                        submission.caseData?.caseTypeID ?? APIModels.EmptyGuid
                    }
                    updateDocument={addDocument}
                    newCase={
                        !submission.caseData?.ucn ||
                        submission.caseData.ucn.length > 0
                    }
                    close={handleDocumentClose}
                />
                {!isLoading ? (
                    <>
                        <div className="row mb-3">
                            <div className="col-12">
                                <CaseInformation
                                    caseData={submission.caseData}
                                    isNewCase={
                                        submission.caseData?.ucn ? false : true
                                    }
                                    saveCaseData={(cd) => {
                                        setSubmission({
                                            ...submission,
                                            caseData: cd,
                                        });
                                        const newStep = currentStep;
                                        if (currentStep === 1) {
                                            setCurrentStep(newStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        {currentStep > 1 && (
                            <>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <PartyTable
                                            submission={submission}
                                            parties={submission.parties ?? []}
                                            onUpdateParties={onUpdateParties}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleDocumentOpen}
                                        >
                                            {" "}
                                            Add Document{" "}
                                        </button>
                                        <MaterialTable
                                            title="Filings"
                                            data={submission.documents ?? []}
                                            options={{
                                                search: false,
                                            }}
                                            columns={[
                                                {
                                                    title: "Filename",
                                                    field: "filename",
                                                    editable: "never",
                                                },
                                                {
                                                    title: "Filing Code",
                                                    field: "filingCode",
                                                    editable: "never",
                                                },
                                                {
                                                    title: "Confidential",
                                                    field: "confidential",
                                                    editable: "never",
                                                    type: "boolean",
                                                },
                                            ]}
                                            editable={{
                                                onRowDelete: (oldData) =>
                                                    new Promise(
                                                        (resolve, _reject) => {
                                                            const newDocuments =
                                                                [
                                                                    ...(submission.documents ??
                                                                        []),
                                                                ];
                                                            newDocuments.splice(
                                                                newDocuments.indexOf(
                                                                    oldData
                                                                ),
                                                                1
                                                            );
                                                            setSubmission({
                                                                ...submission,
                                                                documents:
                                                                    newDocuments,
                                                            });
                                                            resolve(null);
                                                        }
                                                    ),
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <p>Loading... </p>
                )}

                {currentStep >= 3 && (
                    <div className="card" style={{ padding: "2em" }}>
                        <div className="row mb-3">
                            <div className="col-6">
                                <label>Payment Account</label>
                                <Select
                                    options={paymentOptions}
                                    onChange={(
                                        value: MyOptionType | null,
                                        actionMeta: ActionMeta<MyOptionType>
                                    ) => {
                                        console.log(value);
                                        setSubmission({
                                            ...submission,
                                            paymentMethodID: value?.value,
                                        });
                                    }}
                                />
                                <label>Party Responsible</label>
                                <Select
                                    value={partyOptions.filter(
                                        (c) =>
                                            c.value === submission.filingPartyID
                                    )}
                                    filterOption={filterOption}
                                    options={partyOptions}
                                    onChange={(
                                        value: MyOptionType | null,
                                        actionMeta: ActionMeta<MyOptionType>
                                    ) => {
                                        setSubmission({
                                            ...submission,
                                            filingPartyID: value?.value,
                                        });
                                    }}
                                />
                                <label>Filing Attorney</label>
                                <Select
                                    value={attorneyOptions.filter(
                                        (c) =>
                                            c.value ===
                                            submission.filingAttorneyID
                                    )}
                                    filterOption={filterOption}
                                    options={attorneyOptions}
                                    onChange={(
                                        value: MyOptionType | null,
                                        actionMeta: ActionMeta<MyOptionType>
                                    ) => {
                                        setSubmission({
                                            ...submission,
                                            filingAttorneyID: value?.value,
                                        });
                                    }}
                                />
                                {/**<label>Filer Type</label>
                                <Select 
                                    value={filerTypes.filter(
                                        (c) => c.value === submission.filerTypeID
                                    )}
                                    filterOption={filterOption} 
                                    options={filerTypes} 
                                    onChange={( 
                                        value: MyOptionType | null, 
                                        actionMeta: ActionMeta<MyOptionType> 
                                    ) => { 
                                        setSubmission({ 
                                            ...submission, 
                                            f: value?.value, 
                                        }); 
                                    }} 
                                />*/}
                            </div>
                            <div className="col-6">
                                <label>Fee Breakdown</label>
                                {submission.fees ? (
                                    <FeeTable fees={submission.fees} />
                                ) : calculateError !== "" ? (
                                    <p className="text-danger">
                                        {calculateError}
                                    </p>
                                ) : (
                                    <p>No fees calculated yet.</p>
                                )}
                            </div>
                        </div>
                        {isCalculating ? (
                            <div className="btn btn-primary mb-3">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-primary mb-3"
                                onClick={() => {
                                    setIsCalculating(true);
                                    if (
                                        submission.caseData?.ucn &&
                                        submission.caseData?.ucn !== "" &&
                                        submission.caseData?.ucn !==
                                            APIModels.EmptyGuid
                                    ) {
                                        TylerFeeService.existing({
                                            body: submission,
                                        })
                                            .then((res) => {
                                                if (
                                                    res.successful! &&
                                                    res.data
                                                ) {
                                                    setSubmission({
                                                        ...submission,
                                                        fees: res.data,
                                                    });
                                                } else {
                                                    setCalculateError(
                                                        res.errorMessage!
                                                    );
                                                }
                                                setCurrentStep(4);
                                            })
                                            .catch((res) => {
                                                setCalculateError(res);
                                            })
                                            .finally(() => {
                                                setIsCalculating(false);
                                            });
                                    } else {
                                        TylerFeeService.new({
                                            body: submission,
                                        })
                                            .then((res) => {
                                                if (
                                                    res.successful! &&
                                                    res.data
                                                ) {
                                                    setSubmission({
                                                        ...submission,
                                                        fees: res.data,
                                                    });
                                                } else {
                                                    setCalculateError(
                                                        res.errorMessage!
                                                    );
                                                }
                                                setCurrentStep(4);
                                            })
                                            .catch((res) => {
                                                setCalculateError(res);
                                            })
                                            .finally(() => {
                                                setIsCalculating(false);
                                            });
                                    }
                                }}
                            >
                                Calculate Fees
                            </button>
                        )}
                    </div>
                )}

                {currentStep >= 4 && (
                    <div className="card" style={{ padding: "2em" }}>
                        <div className="row mb-3">
                            {!isSubmitting ? (
                                <button
                                    className="btn btn-success p-2"
                                    onClick={() => {
                                        console.log(submission);
                                        TylerEnvelopeService.submit({
                                            body: submission,
                                            isExistingCase:
                                                !submission.caseData?.ucn &&
                                                submission.caseData?.ucn !== "",
                                        })
                                            .then((res) => {
                                                if (
                                                    res.successful! &&
                                                    res.data
                                                ) {
                                                    TylerEnvelopeService.write({
                                                        body: { ...res.data },
                                                    })
                                                        .then((res) => {
                                                            if (
                                                                res.successful! &&
                                                                res.data
                                                            ) {
                                                                return res.data;
                                                            } else {
                                                                throw new Error(
                                                                    "Envolpe was not saved: " +
                                                                        res.errorMessage!
                                                                );
                                                            }
                                                        })
                                                        .then((res) => {
                                                            window.location.href =
                                                                "/" + res;
                                                        });
                                                } else {
                                                    setErrorMessage(
                                                        res.errorMessage!
                                                    );
                                                }
                                            })
                                            .catch((res) => {
                                                setErrorMessage(res);
                                            });
                                    }}
                                >
                                    <i className="ri-government-fill col-sm-3"></i>
                                    <span className="col-sm-9">
                                        Submit to Tyler
                                    </span>
                                </button>
                            ) : (
                                <div className="btn btn-success mb-3">
                                    <div
                                        className="spinner-border"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}
